import type { DateTime } from 'luxon';
import type { BookingMode } from '../enums';
import type { BookableProvider, Service, TimeSlot } from './provider-ui.types';

/**
 * Booking wizard step enum
 * Defines the order of steps in the booking flow
 */
export enum BookingStep {
  PROVIDER = 0,
  SERVICES = 1,
  DATE_TIME = 2,
  REVIEW_AND_PAY = 3,
}

/**
 * Booking state for the wizard
 * Stores all user selections and form inputs during booking
 */
export interface BookingState {
  shopId: string;
  bookingMode?: BookingMode;
  selectedServices: Service[];
  selectedProvider: BookableProvider | null;
  selectedDate: DateTime | null;
  selectedTimeSlot: TimeSlot | null;
  customerName: string;
  customerEmail: string;
  customerPhone: string;
  notes: string;
  acceptedLegalTerms: boolean;
}

/**
 * Booking confirmation details
 * Summary of booking shown before final confirmation
 */
export interface BookingConfirmation {
  shopName: string;
  providerName: string;
  services: Service[];
  appointmentDate: DateTime;
  appointmentTime: string;
  totalDuration: number;
  totalPrice: number;
  customerEmail?: string;
}
